import React from 'react';
import {
  Container, Row, Card, CardBody, Table
} from 'reactstrap';
import Slider from 'react-slide-out';
import 'react-slide-out/lib/index.css';
import * as env from "../../../../env";
import { columnHeader } from "./config";
import Pagination from "../../../../shared/components/pagination/Pagination";
import FormComponent from "./form";
import ProxySubnetsUseCases from "./EditCell/ProxySubnetsUseCases";
import ProxySubnetsTags from "./EditCell/ProxySubnetsTags";
import ProxySubnetsWebsites from "./EditCell/ProxySubnetsWebsites";
import Actions from "./Actions";
import client from "../../../../shared/api-client";
import * as websites from "../../../../shared/service/websites";
import * as nodes from "../../../../shared/service/nodes";
import * as validate from "../../../../shared/validate";
import Modal from "../../../../shared/modal";
import { Link } from "react-router-dom";

class ProxySubnets extends React.Component {
  state = {
    isOpen: false,
    show: false,
    addTitle: 'Add Subnet',
    editTitle: 'Edit Subnet',
    subnets : [],
    filteredSubnets : [],
    websites: [],
    nodes: [],
    columnHeader: columnHeader,
    filters: [],
    filterValues : {
      online : [],
      use_cases : [],
      location : [],
      tags : [],
      websites: [],
      type: []
    },
    startIndex: 0,
    endIndex: env.RECORDS_PER_PAGE,
    formValues: []
  };

  getSubnets() {
    client(`subnets.php`).then((subnets) => {
      subnets.map(subnet => 
        subnet.type = (subnet.type === '' || subnet.type === null) ? 'Premium Private' : subnet.type
      );

      if (this.props.lid !== undefined) {
        subnets = subnets.filter(obj => parseInt(obj.lid) === parseInt(this.props.lid));
      }

      this.setSubnets(subnets);
    });
  }

  setSubnets = (subnets) => {
    this.setState({
      isOpen: false,
      subnets : subnets,
      filteredSubnets: subnets
    });

    let filterValues = this.state.filterValues;

    subnets.map(subnet => {
      this.state.columnHeader.map(header => {
        if (header.type === 'list' || header.type === 'multiple-list') {
          switch (header.key) {
            case 'location':
              if (!filterValues[header.key].includes(subnet[header.key].location)) {
                filterValues[header.key].push(subnet[header.key].location); 
              }
              break;
            case 'use_cases':
              subnet[header.key].forEach((use_case, index) => {
                if (!filterValues[header.key].includes(use_case.use_case)) {
                  filterValues[header.key].push(use_case.use_case); 
                }
              }) 
              break;
            case 'websites':
              subnet[header.key].forEach((website, index) => {
                if (!filterValues[header.key].includes(website.website)) {
                  filterValues[header.key].push(website.website); 
                }
              }) 
              break;
            case 'tags':
              subnet[header.key].forEach((tag, index) => {
                if (!filterValues[header.key].includes(tag.tag)) {
                  filterValues[header.key].push(tag.tag); 
                }
              }) 
              break;
            case 'online':
            case 'type':
              if (!filterValues[header.key].includes(subnet[header.key])) {
                filterValues[header.key].push(subnet[header.key]); 
              }
              break;
            
            default:
              break;
          }
        }

        return header;
      })

      return subnet;
    })
  }

  getUsage = () => {
    client(`proxy_usage.php`).then(
      (usages) => {
        let useCases = usages.data;
        this.setState({useCases});
      },
      (error) => {
        console.error(error);
      }
    );
  };

  getWebsites = () => {
    websites.get().then(response => {
      let websites = [];

      response.data.forEach(website => {
        websites.push({slug: website.id, name: website.name}); 
     });
  
      this.setState({websites});
    });
 
  }

  getTags = () => {
    client(`tag.php`).then(
      (proxyTags) => {
        let tags = proxyTags;
        this.setState({tags});
      },
      (error) => {
        console.error(error);
      }
    );
  };

  componentDidMount() {
    this.getSubnets();
    this.getUsage();
    this.getTags();
    this.getWebsites();
    nodes.get().then(nodes => this.setState({nodes}));
  }

  formChangeHandler = (event) => {
    let filters = this.state.filters;
    let filter = {'name' : event.target.name, 'value' : event.target.value};

    var foundIndex = filters.findIndex(x => x.name === filter.name);

    if (foundIndex >= 0) {
      filters[foundIndex] = filter;
    } else {
      filters.push(filter);
    }

    this.setState({filters});
    this.filterResults();
  }

  filterResults = () => {
    let filteredSubnets = this.state.subnets;

    this.state.filters.forEach((element, index) => {
      if (element.value.trim() !== '') {
        switch (element.name) {
          case 'sid':
          case 'subnet':
          case 'ip':
          case 'geo_maxmind':
            filteredSubnets = filteredSubnets.filter(o =>
              Object.keys(o).some(k => String(o[element.name]).toLowerCase().includes(element.value.toLowerCase()))
            );
            break;          
          case 'created':
          case 'users':
          case 'type':
          case 'maxmind':
            filteredSubnets = filteredSubnets.filter(o =>
              Object.keys(o).some(k => o[element.name].toLowerCase().includes(element.value.toLowerCase()))
            );
            break;
          case 'online':
            filteredSubnets = filteredSubnets.filter(o =>
              Object.keys(o).some(k => o[element.name] === element.value)
            );
            break;
          case 'location':
            filteredSubnets = filteredSubnets.filter(o =>
              Object.keys(o).some(k => o[element.name]['location'].includes(element.value))
            );
            break;
          case 'use_cases':
            filteredSubnets = filteredSubnets.filter(item => 
              item['use_cases'].filter(use_case =>  
                use_case.use_case.indexOf(element.value) > -1
              ).length > 0
            );
            break;
          case 'websites':
            filteredSubnets = filteredSubnets.filter(item => 
              item['websites'].filter(website =>  
                website.website.indexOf(element.value) > -1
              ).length > 0
            );
            break;
          case 'tags':
            filteredSubnets = filteredSubnets.filter(item => 
              item['tags'].filter(tag =>  
                tag.tag.indexOf(element.value) > -1
              ).length > 0
            );
            break;
          default:
            break;
        } 
      }
    });
  
    
    this.setState({filteredSubnets});
  }

  printFilters = () => {
    return (<tr >
      {this.state.columnHeader.map((data, index) => (data.filter) ? (<th key={index} > {this.printFilterInput(data)}</th>): <th key={index}></th>)}
    </tr>);
  }

  printFilterInput = (input) => {
    if (input.type === 'text')
        return (<input name={input.key} type="text" onChange={this.formChangeHandler}></input>);
    else if (input.type === 'list' || input.type === 'multiple-list')
        return (<select name={input.key} type="text" onChange={this.formChangeHandler}>
          <option value="">All</option>
          {this.printOptions(input.key)}
        </select>);
  }

  printOptions = (key) => {

    return <React.Fragment>
      {this.state.filterValues[key].map((value, index) => ( <option key={index} value={value}>{value}</option> ))}
      
    </React.Fragment>
  };

  toggleCell = (id, key, value) => {
    let subnets = this.state.subnets;

    subnets.map((subnet) => {
      if (subnet.id === id) {
        subnet[key] = value;
      }

      return subnet;
    });

    let filteredSubnets = this.state.filteredSubnets;

    filteredSubnets.map((subnet) => {
      if (subnet.id === id) {
        subnet[key] = value;
      }

      return subnet;
    });

    this.setState({filteredSubnets});
  }

  printNode = (lid) => {
    let node = this.state.nodes.filter(node => node.lid === lid);

    if (node.length > 0) {
      return (<React.Fragment>
        {node.shift().name}
      </React.Fragment>);
    } else {
      return (<React.Fragment></React.Fragment>);
    }
  }

  printRecords = () => {
    let items = this.state.filteredSubnets.slice(this.state.startIndex, this.state.endIndex + 1);

    return (<React.Fragment>
		  {items.map(data => (
			<tr key={data.sid}>
        <td>{this.printNode(data.lid)}</td>
			  <td>{data.subnet}</td>
        <td>{data.ip}</td>
        <td>{data.type}</td>
			  <td>{data.online}</td>
			  <td>
				  <ProxySubnetsUseCases useCases={this.state.useCases} key={data.id} subnet={data} toggleCell={this.toggleCell} updateSubnet={this.updateSubnet} />
			  </td>
        <td>
				  <ProxySubnetsWebsites websites={this.state.websites} key={data.id} subnet={data} toggleCell={this.toggleCell} updateSubnet={this.updateSubnet} />
			  </td>
			  <td>
				  <ProxySubnetsTags tags={this.state.tags} key={data.id} subnet={data} toggleCell={this.toggleCell} updateSubnet={this.updateSubnet} />
			  </td>
        <td>{data.geo_maxmind}</td>
			  <td>
          <Link to={() => { return this.usersListingUrl(data)}} >
            {data.users}
          </Link>
        </td>
			  <td><Actions onEditClicked={() => (this.toggleEditSubnet(data))}  item={data} /></td>
			</tr>
		  ))}
		</React.Fragment>);
	}

	pagination = () => {
	  return this.state.filteredSubnets.length > env.RECORDS_PER_PAGE ? (
		<div className="audit-trail-footer">
		  <Pagination
			items={this.state.filteredSubnets}
			onChangePage={(pagination) => this.setState(pagination)}
			pageSize={env.RECORDS_PER_PAGE}
		  />
		</div>
	  ) : (
		""
	  )
  }
  
  usersListingUrl = (subnet) => {
    return `/proxy/subnets/users/${subnet.sid}`
  }

	toggleEditSubnet = (editable) => {
    this.setState({editable});
	  this.setState(prevState => ({ isOpen: !prevState.isOpen }));
	}

	toggleAddNewSubnet = () => {
	  this.setState(prevState => ({ isOpen: !prevState.isOpen }));
	}

  handleForm = (formValues) => {
    this.setState({ formValues }, () => {
      // Validations will be added here if required frontend validations
    });
  };

  updateSubnet = (formValues) => {
    this.setState({formValues}, () => {
      this.submit();
    });
  };

  submit = () => {

    let errors = [];

    if (this.state.formValues.subnet === undefined 
      || !validate.required(this.state.formValues.subnet)
      || !validate.subnetRange(this.state.formValues.subnet)) {
      errors.push('Please enter the valid subnet.');
    }

    if (this.state.formValues.ip === undefined || !validate.required(this.state.formValues.ip) || !validate.ip(this.state.formValues.ip)) {
      errors.push('Please enter the valid IP.');
    }

    if (this.state.formValues.type === undefined || !validate.required(this.state.formValues.type)) {
      errors.push('Please select the type.');
    }

    if (this.state.formValues.online === undefined || !validate.required(this.state.formValues.online)) {
      errors.push('Please select the online.');
    }

    if (errors.length > 0) {
      this.setState({
        show: true,
        success: "",
        errors: errors,
      });

      return false;
    }

    let method = "PUT";

    if (this.state.formValues !== undefined && this.state.formValues.sid !== undefined) {
      method = "POST";
    }

    client(`subnets.php`, {
      method: method,
      body: this.state.formValues,
    }).then(
      (response) => {
        this.getSubnets();
        this.getUsage();
        this.getTags();
        this.setState({
          isOpen: false,
          show: false,
          errors: [],
        });
      },
      (error) => {
        this.setState({
          show: true,
          errors: error._user_message,
          success: "",
        });
      }
    );
  };

	printActions = () => {
	  return <React.Fragment>
		<button type="button" onClick={() => {
        let editable = {};
        this.setState({editable});
        this.toggleAddNewSubnet() 
      }} className="btn btn-sm btn-primary">{this.state.addTitle}</button>
	  </React.Fragment>
	}

	render() {
		return (
		  <Container>
			<Row className="user-section">
			  <Card className="table-section form">
				<CardBody>
				  <div className="card__title">
					<h5 className="bold-text">Subnets</h5>
					<div className="toolbar-buttons">
					  {this.printActions()}
					</div>
				  </div>
				  <Table responsive hover className="table--head-accent table--bordered">
					<thead>
					  <tr>
						{this.state.columnHeader.map(data => (<th key={data.key}>{data.name}</th>))}
					  </tr>
					  {this.printFilters()}
					</thead>
					<tbody >
					  {this.printRecords()}
					</tbody>
				  </Table>
				  {this.pagination()}
				</CardBody>
			  </Card>
			</Row>
			<Slider
			  isOpen={this.state.isOpen}
			  footer={(
				<div className="button-container">
				  <button className="square btn btn-primary btn-sm" onClick={() => this.submit()} type="button">Submit</button>
				  <button type="button" className="square btn btn-danger btn-sm" onClick={() => this.toggleAddNewSubnet()}>
					Cancel
				  </button>
				</div>
			  )}
			  onOutsideClick={() => this.setState({ isOpen: false })}
			>
			  <FormComponent 
          title={(this.state.editable !== undefined && this.state.editable.sid !== undefined) ? this.state.editTitle : this.state.addTitle}  
          handleForm={(formValues) => this.handleForm(formValues)}  
          nodes={this.state.nodes}
          edit={() => {
            return this.state.editable;
          }} />
			</Slider>
			<Modal
          onClose={() => this.setState({ show: false })}
          show={this.state.show}
          errors={this.state.errors}
          success={this.state.success}
        ></Modal>
		  </Container>
		);
	}
}

export default ProxySubnets;
